export interface BirthdayMessageTemplates {
    smsText: string;
    whatsAppText: string;
    emailName: string;
    emailSubject: string;
    emailText: string;
}

const defaults: Record<'pt' | 'en' | 'fr', BirthdayMessageTemplates> = {
    pt: {
        smsText: `Olá {client-name}! A equipa da {company-name} deseja-lhe um feliz aniversário! 🎂 Obrigado por ser nosso cliente!`,
        whatsAppText: `Olá {{client_name}}!\n\nA equipa da {{company_name}} deseja-lhe um muito feliz aniversário! 🎂🎉\n\n{{custom_farewell}}\nCom os melhores cumprimentos.`,
        emailName: '{company-name}',
        emailSubject: 'Feliz Aniversário! 🎂',
        emailText: `<p>Olá {client-name}!</p><p> </p><p>A equipa da <b>{company-name}</b> deseja-lhe um muito <b>Feliz Aniversário</b>! 🎂🎉</p><p> </p><p>Obrigado por ser nosso cliente. É um prazer tê-lo(a) connosco e esperamos continuar a servi-lo(a) por muitos anos.</p><p> </p><p>Com os melhores cumprimentos,<br/><b>{company-name}</b></p>`,
    },
    en: {
        smsText: `Hi {client-name}! The {company-name} team wishes you a very Happy Birthday! 🎂 Thank you for being our client!`,
        whatsAppText: `Hi {{client_name}}!\n\nThe {{company_name}} team wishes you a very Happy Birthday! 🎂🎉\n\n{{custom_farewell}}\nBest regards.`,
        emailName: '{company-name}',
        emailSubject: 'Happy Birthday! 🎂',
        emailText: `<p>Hi {client-name}!</p><p> </p><p>The <b>{company-name}</b> team wishes you a very <b>Happy Birthday</b>! 🎂🎉</p><p> </p><p>Thank you for being our client. It is a pleasure having you with us and we hope to keep serving you for many years to come.</p><p> </p><p>Best wishes,<br/><b>{company-name}</b></p>`,
    },
    fr: {
        smsText: `Bonjour {client-name} ! L'équipe de {company-name} vous souhaite un très joyeux anniversaire ! 🎂 Merci d'être notre client !`,
        whatsAppText: `Bonjour {{client_name}} !\n\nL'équipe de {{company_name}} vous souhaite un très joyeux anniversaire ! 🎂🎉\n\n{{custom_farewell}}\nCordialement.`,
        emailName: '{company-name}',
        emailSubject: 'Joyeux Anniversaire ! 🎂',
        emailText: `<p>Bonjour {client-name} !</p><p> </p><p>L'équipe de <b>{company-name}</b> vous souhaite un très <b>Joyeux Anniversaire</b> ! 🎂🎉</p><p> </p><p>Merci d'être notre client. C'est un plaisir de vous avoir avec nous et nous espérons continuer à vous servir pendant de nombreuses années.</p><p> </p><p>Cordialement,<br/><b>{company-name}</b></p>`,
    },
};

export const getBirthdayMessageDefaults = (lang: 'pt' | 'en' | 'fr'): BirthdayMessageTemplates =>
    defaults[lang] ?? defaults.pt;
